import React, { useEffect } from "react";
import "./Component5.css";
import mic from "../img/mic.jpeg";
import kate from "../img/kate.jpeg";
import AOS from "aos";
import "aos/dist/aos.css";

const Component5 = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div className="main">
      <div>
        <h1 className="h22">Clients Testimonial</h1>
      </div>
      <div className="flex_div001">
        <div className="fleex" data-aos="fade-right">
          <img className="img5" src={mic} alt="Mr & Mrs Micheal" />
          <p className="p55">
            Awesome experience! We decided to take a last minute trip to Beacon
            from NYC for a winery day trip. The driver called me immediately to
            set up our ride and accommodated all of our requests. The sprinter
            van was brand new + the driver was very professional. Will
            definitely be using BENTRACO LOGISTICS again!
          </p>
          <h5>Mr & Mrs Micheal</h5>
        </div>
        <div className="fleex" data-aos="fade-left">
          <img className="img5" src={kate} alt="Mrs Kate" />
          <p className="p55">
            Had a spectacular experience with BENTRACO limo service. I had to
            make a last minute reservation and they made the process seamless
            and very competitive. They were near 25% better than other
            companies. The black suburban we were picked up in was in perfect
            condition.
          </p>
          <h5>Mrs Kate</h5>
        </div>
      </div>
    </div>
  );
};

export default Component5;
